import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { AuditList } from '@/components/admin/AuditList';
import { fetchAdminAudit } from '@/services/adminApi';
import type { AuditEntry } from '@/types/admin';

function AuditLog() {
  const { t } = useTranslation('admin');
  const [entries, setEntries] = useState<AuditEntry[] | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    fetchAdminAudit(200, controller.signal)
      .then(setEntries)
      .catch(() => {
        if (!controller.signal.aborted) {
          setError(true);
        }
      });
    return () => controller.abort();
  }, []);

  let body = (
    <p className="kicker m-0 py-12" aria-live="polite">{t('loading')}</p>
  );
  if (error) {
    body = <p className="m-0 py-12 text-sm text-ink-2">{t('audit.loadFailed')}</p>;
  } else if (entries) {
    body = <AuditList entries={entries} showEvent />;
  }

  return (
    <div>
      <header className="flex flex-col gap-2 border-b border-rule pb-5">
        <h1 className="m-0 text-[1.75rem] md:text-[2rem]">{t('nav.audit')}</h1>
        <p className="m-0 text-sm text-ink-2">{t('audit.description', { count: 200 })}</p>
      </header>
      <section className="mt-6 border-t-2 border-ink">{body}</section>
    </div>
  );
}

export function AdminAuditPage() {
  return (
    <AdminLayout>
      <AuditLog />
    </AdminLayout>
  );
}
